import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CurrencyPipe} from "@angular/common";

@Component({
  selector: 'pipelines-panel-project-credits',
  imports: [
    CurrencyPipe
  ],
  templateUrl: './pipelines-panel-project-credits.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-project-credits.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelProjectCreditsComponent implements OnInit{
  @Input() detail:any;
  public expanded:boolean = false;
  public dataArr:any[] = []

  ngOnInit() {
    if(Array.isArray(this.detail.tax_credits)){
      this.dataArr = this.detail.tax_credits;
    } else {
      for(let i = 0 ; i < Object.keys(this.detail.tax_credits).length; i++){
        this.dataArr.push(this.detail.tax_credits[i])
      }
    }
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }

}
